import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Zap } from 'lucide-react';
export function Hero() {
  const [showPopup, setShowPopup] = useState(true);
  return <section className="relative w-full min-h-screen flex flex-col justify-center items-center px-6 py-20 bg-cream overflow-hidden" data-id="element-186">
      {/* Subtle background texture/pattern elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30" data-id="element-187">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-terracotta-light blur-[120px]" data-id="element-188"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-amber-light blur-[150px]" data-id="element-189"></div>
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-190">
        <FadeIn data-id="element-191">
          <span className="inline-block py-1 px-3 rounded-full bg-terracotta/10 text-terracotta text-sm font-bold tracking-wider uppercase mb-6" data-id="element-192">
            Plan Cero Gritos Post-Pantalla
          </span>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-193">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-charcoal leading-tight mb-8" data-id="element-194">
            Tu Hijo{' '}
            <span className="text-terracotta italic" data-id="element-195">No Es Difícil</span>.<br data-id="element-196" />
            Su Cerebro Está Atrapado en la Pantalla.
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-197">
          <p className="text-xl md:text-2xl text-charcoal-light font-medium max-w-2xl mx-auto leading-relaxed mb-12" data-id="element-198">
            Y cada vez que le gritas para que la apague... el problema se hace
            más grande.
          </p>
        </FadeIn>

        {/* Product Cover Image */}
        <FadeIn delay={0.3} data-id="element-199">
          <div className="relative inline-block max-w-2xl w-full" data-id="element-200">
            <motion.div initial={{
            y: 20,
            rotateX: 8
          }} animate={{
            y: 0,
            rotateX: 0
          }} transition={{
            duration: 1,
            ease: 'easeOut',
            delay: 0.5
          }} className="relative" style={{
            perspective: '1000px'
          }} data-id="element-201">
              <img src="https://cdn.magicpatterns.com/uploads/sYoCYijoDSPJFjW5eHWFiU/PANTALLA_HORIZONTAL.png" alt="Plan Pantalla Sin Drama — Portada del libro digital" className="w-full rounded-2xl shadow-2xl shadow-charcoal/20 border-4 border-white" data-id="element-202" />
              {/* Subtle glow behind the image */}
              <div className="absolute inset-0 -z-10 bg-terracotta/20 blur-[40px] rounded-3xl scale-90" data-id="element-203"></div>
            </motion.div>
          </div>
        </FadeIn>
      </div>

      {/* Animated Offer Popup */}
      <AnimatePresence data-id="element-204">
        {showPopup && <motion.div initial={{
        scale: 0,
        opacity: 0,
        rotate: -10
      }} animate={{
        scale: 1,
        opacity: 1,
        rotate: 0
      }} exit={{
        scale: 0,
        opacity: 0,
        rotate: 10
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 18,
        delay: 1.2
      }} className="fixed bottom-6 right-6 z-50 md:bottom-8 md:right-8" data-id="element-205">
            <motion.div animate={{
          y: [0, -6, 0],
          boxShadow: ['0 4px 30px rgba(232, 97, 77, 0.3)', '0 8px 50px rgba(232, 97, 77, 0.6)', '0 4px 30px rgba(232, 97, 77, 0.3)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative bg-terracotta text-white rounded-2xl p-5 pr-10 md:p-6 md:pr-12 cursor-pointer" onClick={() => {
          const ctaSection = document.querySelector('#final-cta-section');
          if (ctaSection) ctaSection.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-206">
              {/* Pulsing ring */}
              <motion.div animate={{
            scale: [1, 1.15, 1],
            opacity: [0.5, 0, 0.5]
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} className="absolute inset-0 rounded-2xl border-2 border-terracotta-light" data-id="element-207"></motion.div>

              {/* Close button */}
              <button onClick={e => {
            e.stopPropagation();
            setShowPopup(false);
          }} className="absolute top-2 right-2 w-6 h-6 bg-white/20 hover:bg-white/40 rounded-full flex items-center justify-center transition-colors" aria-label="Cerrar oferta" data-id="element-208">
                <X className="w-3.5 h-3.5 text-white" data-id="element-209" />
              </button>

              <div className="flex items-center gap-3 relative z-10" data-id="element-210">
                <motion.div animate={{
              rotate: [0, -15, 15, -15, 0]
            }} transition={{
              duration: 0.6,
              repeat: Infinity,
              repeatDelay: 3
            }} data-id="element-211">
                  <Zap className="w-8 h-8 md:w-10 md:h-10 text-amber fill-amber" data-id="element-212" />
                </motion.div>
                <div data-id="element-213">
                  <p className="text-xs md:text-sm font-bold uppercase tracking-wider text-white/80" data-id="element-214">
                    🔥 Oferta Hoy
                  </p>
                  <p className="text-3xl md:text-4xl font-bold font-serif" data-id="element-215">
                    $11<span className="text-2xl md:text-3xl" data-id="element-216">,99</span>
                  </p>
                  <p className="text-xs text-white/70 line-through" data-id="element-217">
                    $15.99 USD
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Decorative wave separator at bottom */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-218">
        <svg className="relative block w-full h-[50px] md:h-[80px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-219">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,119.93,197.36,97.7,243.9,82.22,285.34,63.11,321.39,56.44Z" className="fill-white" data-id="element-220"></path>
        </svg>
      </div>
    </section>;
}